import { dateFormatedToDB } from "../../functions";
import { CustomersReportModel } from "../../models/reports";

export default class CustomersReportController {
  constructor() {
    this.name = "reports-customers";
    this.tableName = `${this.name}-table`;
    this.paginationName = `${this.name}-pagination`;

    this.MCustomersReport = CustomersReportModel();

    this.init();
  }

  init = async () => {
    this.findCustomersReport();
  };

  findCustomersReport = async () => {
    await this.MCustomersReport.findCustomersReport();
  };

  setPage = (page) => {
    this.MCustomersReport.setPage(page);
  };

  setFilter = (filterData) => {
    const filter = { ...filterData };

    if ("dateFrom" in filter) filter.dateFrom = dateFormatedToDB(filter.dateFrom);
    if ("dateTo" in filter) filter.dateTo = dateFormatedToDB(filter.dateTo);

    this.MCustomersReport.setFilter(filter);
  };

  clearFilter = async () => {
    this.MCustomersReport.setFilter({
      hasPackage: "*",
      isSubscriber: "*",
      minAbsenceDays: "30",
      cpf: "",
      search: "",
    });

    await this.filterCustomers();
  };

  /**
   * Atalho dos KPIs: clicar aplica o filtro, clicar de novo limpa.
   * Escreve no mesmo filtro da store e refaz a busca — nao filtra em memoria,
   * senao a paginacao passa a mentir.
   */
  toggleFilter = async (key, value) => {
    const current = this.MCustomersReport.currentFilter()[key];

    this.MCustomersReport.setFilter({ [key]: current === value ? "*" : value });
    await this.filterCustomers();
  };

  /**
   * `Table.Header` chama onSort(sortKey) com UM argumento.
   * Clicar na mesma coluna inverte a direcao; em outra coluna, comeca em asc.
   */
  handleSortColumn = async (sortBy) => {
    const current = this.MCustomersReport.currentSort();

    const sortOrder =
      current.sortBy === sortBy && current.sortOrder === "asc" ? "desc" : "asc";

    this.MCustomersReport.setSort({ sortBy, sortOrder });
    await this.filterCustomers();
  };

  filterCustomers = async (e) => {
    if (e) e.preventDefault();
    await this.MCustomersReport.filterCustomersReport();
  };

  reportExport = () => {
    this.MCustomersReport.export();
  };
}
